import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription, switchMap } from 'rxjs';
import { ProductData } from 'src/app/modules/pim-graphql/views/product-view/product.model';
import { ProductService } from 'src/app/modules/pim-graphql/views/product-view/product.service';
import { RefreshService } from 'src/app/services/refresh.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  standalone: false,
})
export class ProductComponent implements OnInit, OnDestroy {
  private productService = inject(ProductService);
  private route = inject(ActivatedRoute);
  private refreshService = inject(RefreshService);

  product?: ProductData;
  loading = true;
  private paramSubscription?: Subscription;

  ngOnInit(): void {
    this.paramSubscription = combineLatest([
      this.route.params,
      this.refreshService.refreshData$,
    ])
      .pipe(
        switchMap((values) => {
          const id: string = values[0]['productId'];
          this.product = undefined;
          this.loading = true;
          return this.productService.getProductData(id);
        }),
      )
      .subscribe((product) => {
        this.product = product;
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.paramSubscription?.unsubscribe();
  }
}
